<template>
  <div>
    <p class="mb-1 d-block d-sm-inline-block text-center text-sm-left text--secondary">
      {{ $t('label.share') }}
    </p>
    <div class="d-flex justify-space-around">
      <a
        :id="buttonsId.fb"
        target="_blank"
        class="fb-xfbml-parse-ignore primary-link d-inline-block mb-0"
        @click="fbShare"
      >
        <v-icon
          :size="iconSize"
          color="szViolet"
        >$fb</v-icon>
      </a>
      <a
        :id="buttonsId.msg"
        target="_blank"
        class="fb-xfbml-parse-ignore primary-link d-inline-block mb-0"
        @click="fbSend"
      >
        <v-icon
          :size="iconSize"
          color="szViolet"
        >$messenger</v-icon>
      </a>
    </div>
  </div>
</template>

<script>
import { APP_ID } from '@/constants/fb_app';
import { isMobile } from 'is-mobile';

export default {
    name: 'ShareButtons',
    props: {
        shareUrl: {
            required: true,
            type: String
        },
        buttonsId: {
            type: Object,
            default: () => {
                return {
                    fb: false,
                    msg: false
                };
            }
        },
        iconSize: {
            type: Number,
            default: 28
        }
    },
    methods: {
        fbSend () {
            if (isMobile()) {
                this.fbMessengerShare();
                return;
            }
            window.FB.ui({
                method: 'send',
                link: this.shareUrl + '?utm_source=messenger&utm_medium=referral&utm_campaign=paczka2019&utm_content=swr-messenger-share'
            });
        },
        fbShare () {
            window.FB.ui({
                method: 'share',
                href: this.shareUrl + '?utm_source=facebook&utm_medium=referral&utm_campaign=paczka2019&utm_content=swr-fb-share'
            });
        },
        fbMessengerShare () {
            window.open('fb-messenger://share?link=' + encodeURIComponent(this.shareUrl + '?utm_source=messenger&utm_medium=referral&utm_campaign=paczka2019&utm_content=swr-messenger-share') +
        '&app_id=' + encodeURIComponent(APP_ID));
        }
    }
};
</script>

<style scoped></style>
